import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from '../store'
// import router from '../router'


// const API_URL = 'http://44.235.137.130'
// const API_URL = 'http://localhost:8080'

const plainAxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL
})

const securedAxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

securedAxiosInstance.interceptors.request.use(config => {
  const method = config.method.toUpperCase()
  if (method !== 'OPTIONS' && method !== 'GET') {
    config.headers = {
      ...config.headers
    }
  }
  return config
})

securedAxiosInstance.interceptors.response.use(null, error => {
  if (error.response && error.response.config && error.response.status === 401) {
    store.commit('unsetCurrentUser')
    // router.push({ name: 'signin' })
    window.location.href = process.env.VUE_APP_API_URL + '/login'
  } else {
    return Promise.reject(error)
  }
})

plainAxiosInstance.interceptors.response.use(null, error => {
  if (error.response && error.response.config && error.response.status === 401) {
    store.commit('unsetCurrentUser')
    // router.push({ name: 'signin' })
    window.location.href = process.env.VUE_APP_API_URL + '/login'
  } else {
    return Promise.reject(error)
  }
})


Vue.use(VueAxios, { plain: plainAxiosInstance, secured: securedAxiosInstance })
